import React from "react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StoreProvider } from "./store";
import ReactDOMClient from "react-dom/client";
import "./index.scss";
import { reportWebVitalsToGTM } from "./utils/webVitalsGTM";

const root = ReactDOMClient.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </React.StrictMode>
);

// Send core web vitals into Google Tag Manager
reportWebVitals(reportWebVitalsToGTM);
